import React from 'react';
import { Box, Skeleton, Grid } from '@mui/material';

const UsageSkeleton: React.FC = () => {
  return (
    <Box sx={{ py: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Skeleton variant="circular" width={40} height={40} />
      </Box>

      <Grid container spacing={3}>
        {/* Date Range Selector Skeleton */}
        <Grid item xs={12} md={4}>
          <Box sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 2 }}>
            <Skeleton variant="text" width="30%" height={20} sx={{ mb: 2 }} />
            <Skeleton variant="rectangular" width="100%" height={56} sx={{ borderRadius: 1 }} />
          </Box>
        </Grid>

        {/* Empty space */}
        <Grid item xs={12} md={4}></Grid>

        {/* Metric Cards Skeleton */}
        <Grid item xs={12} md={4}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Box sx={{ p: 2, border: '1px solid #e0e0e0', borderRadius: 2 }}>
                <Skeleton variant="text" width="60%" height={20} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="80%" height={24} />
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box sx={{ p: 2, border: '1px solid #e0e0e0', borderRadius: 2 }}>
                <Skeleton variant="text" width="70%" height={20} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="90%" height={24} />
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box sx={{ p: 2, border: '1px solid #e0e0e0', borderRadius: 2 }}>
                <Skeleton variant="text" width="80%" height={20} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="100%" height={24} />
              </Box>
            </Grid>
          </Grid>
        </Grid>

        {/* Chart Skeleton */}
        <Grid item xs={12}>
          <Box sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 2 }}>
            <Skeleton variant="text" width="40%" height={24} sx={{ mb: 3 }} />
            <Skeleton variant="rectangular" width="100%" height={400} sx={{ borderRadius: 1 }} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UsageSkeleton;
